
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire4ff2"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire4ff2"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("c2ZQb", function(module, exports) {

$parcel$export(module.exports, "register", function () { return $8c55a43a6d03f7fc$export$6503ec6e8aabbaf; }, function (v) { return $8c55a43a6d03f7fc$export$6503ec6e8aabbaf = v; });
$parcel$export(module.exports, "resolve", function () { return $8c55a43a6d03f7fc$export$f7ad0328861e2f03; }, function (v) { return $8c55a43a6d03f7fc$export$f7ad0328861e2f03 = v; });
var $8c55a43a6d03f7fc$export$6503ec6e8aabbaf;
var $8c55a43a6d03f7fc$export$f7ad0328861e2f03;
"use strict";
var $8c55a43a6d03f7fc$var$mapping = new Map();
function $8c55a43a6d03f7fc$var$register(baseUrl, manifest) {
    for(var i = 0; i < manifest.length - 1; i += 2)$8c55a43a6d03f7fc$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $8c55a43a6d03f7fc$var$resolve(id) {
    var resolved = $8c55a43a6d03f7fc$var$mapping.get(id);
    if (resolved == null) throw new Error("Could not resolve bundle with id " + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$8c55a43a6d03f7fc$export$6503ec6e8aabbaf = $8c55a43a6d03f7fc$var$register;
$8c55a43a6d03f7fc$export$f7ad0328861e2f03 = $8c55a43a6d03f7fc$var$resolve;

});

var $a13bc9479345db64$exports = {};

(parcelRequire("c2ZQb")).register(new URL("", import.meta.url).toString(), JSON.parse('["gaQ3F","index.07950917.js","jrO0I","about.d4f15197.js","iijKw","home.14dd749b.js","eHq3x","header-brand.6cfc25fb.js","5ieqk","page-footer.f2516c6d.js","c2oVc","discharge-cover.0953b596.png","6405c","discharge.data.31d1678b.js","lexnQ","flood-extent-cover.0b0bf217.png","i7i49","flood-extent-emsr861.data.1f308ab1.js","8IWKC","flood-extent.data.e7b1e81a.js","64ILz","ivt-cover.d437c436.png","dpZah","ivt.data.d6be06e2.js","5g9hv","mslp-cover.d437c436.png","g90IU","mslp.data.fd3ef475.js","4cfgq","precipitation-cover.d437c436.png","9rX33","precipitation.data.ddd445fd.js","iXLK5","precondition-cover.d437c436.png","eJkFA","precondition.data.054bb9c1.js","3diZK","soil-moisture-cover.413b7a89.png","145L6","soil-moisture.data.14f96701.js","ls0VY","sst-cover.b2c25817.png","3xTRQ","sst-anomaly.data.54b6e544.js","lHJWb","hero-sentinel1-tejo.48ab182c.jpg","7vmgX","winter-2025-26-floods.stories.413beef1.js","fB2Me","discharge-timeseries.275a5949.csv","6MqbD","a1-collapse-coimbra.4433a2f4.jpg","hKP2q","rainfall-anomaly.e28b8cf3.png","d5uze","discharge-comparison-story.6e447a71.png","9cJHx","gpm-precipitation-iberia-feb01-07.af96b6f5.jpg","9qzCm","mdx-content.52794019.js","kYATx","mdx-content.e6252c81.js","htJtf","xlsx.1611f9c4.js","jJyUv","mdx-content.ad640c42.js","45KJ1","mdx-content.6d64eac3.js","4ySmc","mapbox-gl.4bedbe5f.js","dvV8K","marker-sdf.db41bce1.png","gF4Uh","tour-comparison.b4c28c2d.gif","99K5W","tour-analysis.af1a1ea4.gif","5GpFz","mdx-content.f15dd9ad.css","gsggZ","catalog-content.ffab9ec4.js","i5MVP","catalog-content.6cc65ddc.css","acHZl","catalog-content.ac010ad2.js","8rH40","container.166f7105.js","29E3J","mdx-content.d7444b6e.js","acFma","mdx-content.8b06dd1f.js","5SZE5","mdx-content.88f4b215.js","6ER2D","mdx-content.076287e8.css","j33My","mdx-content.15ff18cc.css","aMVBk","mdx-content.9b50a707.js","avoOE","mdx-content.653ac370.js","i2H3D","banner.5f5f6a32.js","kjA96","site-alert.cb6934ed.js","k67i3","cookie-consent.15c13901.js","lkVn7","cookie-consent.3df9ee95.css","5DzEx","home.6e8f9fce.js","2YRgc","root-welcome--cover.eec7a022.jpg","e3ggi","vp-01-illu.e16a91f2.png","6qbIp","vp-02-illu.23aae56a.png","aGLcX","vp-03-illu.2016f6ab.png","lQ1ZN","user-enthusiasts.d134e85d.jpg","awWYo","user-scientists.0f1d1c3c.jpg","5W4t4","user-researcher.a227a485.jpg","lP1ss","about.5f0ddd36.js","78qPQ","development.947be44d.js","1S0EW","container.72af27bc.js","cqtD8","container.a7303cfc.js","irjDz","single.3aab2df9.js","1admA","container.8c78b7a4.js","duyAf","s-overview.b8eb587b.js","c2JEr","exploration.ee031062.js","5HVao","sandbox.d7d6b077.js","ewKhE","page.d9aa2821.js","3Yokn","img-placeholder-5.6262760b.jpg","3jGJC","page.dbd895a9.js","6rNJb","chart.3937c688.js","cmjzR","aq.4cb7c0a2.csv","gotJu","two-column.ac7a3449.csv","jciGI","sample.57667550.json","ig0bI","table.838df5e1.js","e7ycI","sandbox.3ea8c494.css","8HO9c","user-pages.b05ec3b1.js"]'));


//# sourceMappingURL=index.runtime.ee7c9a8d.js.map
